import React from "react";
import LoginPage from "./pages/LoginPage/LoginPage";
import MainPage from "./pages/MainPage/MainPage";
import PrivateRoute from "./pages/PrivateRoute/PrivateRoute";
import MyNavBar from "./components/MyNavBar/MyNavBar";
import { withCookies } from "react-cookie";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function App(props) {
  const { cookies } = props;

  const fbToken = cookies.get("fbsr_" + process.env.REACT_APP_FB_APP_ID);
  const isAuthed = fbToken != null && fbToken.length > 0;
  const fbUid = cookies.get("fb_uid");

  return (
    <React.Fragment>
      <MyNavBar isAuthed={isAuthed} fbUid={fbUid} cookies={cookies} />
      <Router>
        <Switch>
          <Route
            path={`${process.env.REACT_APP_URL_ROOT}login`}
            component={LoginPage}
          />
          <PrivateRoute
            isAuthed={isAuthed}
            path={process.env.REACT_APP_URL_ROOT}
            component={MainPage}
          />
        </Switch>
      </Router>
      <ToastContainer position="bottom-center" autoClose={2000} />
    </React.Fragment>
  );
}

export default withCookies(App);
